import {AssertUtils,QueryCommand,GoingUtils} from "goingutils";

//图片展示组件
class ImgShowObj {
    constructor(vueObj) {
        this.vueObj=vueObj;
        this.recordIds=[];
    }
}

//根据值 选中或者不选中相应记录
ImgShowObj.prototype.selectAll = function (value) {
    let ids=[];
    if(this.vueObj.items&&AssertUtils.isArray(this.vueObj.items)){
        this.vueObj.items.forEach(function (item) {
            item.selFlag = value;
            if(value){
                ids.push(item["id"]);
            }
        });
    }

    this.recordIds=ids;
};



ImgShowObj.prototype.destructor = function () {
    this.totalCount = null;
    this.items = null;
    this.recordIds = null;
    this.curPageNum = null;
    this.pageSize = null;
    this.vueObj=null;
};
//获取选择的数据
ImgShowObj.prototype.getSelectedRowIds = function (type) {
    if (type === "string") {
        return this.recordIds.join(GoingUtils.relChart);
    } else {
        return this.recordIds;
    }
};
//加载数据
ImgShowObj.prototype.reloadData = function (successFun) {
    this.flushImgByUrl({url: this.url, params: this.params,successFun});
};

//获取图片的id
ImgShowObj.prototype.getSelectedRowImgIds = function () {
    let imgNames = [];
    let imgShowObj = this;
    this.recordIds.forEach(function (rowId) {
        for (let num = 0; num < imgShowObj.vueObj.items.length; num++) {
            let itemObj = imgShowObj.vueObj.items[num];
            if (itemObj.id === rowId) {
                imgNames.push(itemObj.url);
            }
        }
    });
    return imgNames;
};
//获取图片的url
ImgShowObj.prototype.getImgNames = function (rowIds) {
    //如果传入的不是数组
    if(typeof(rowIds)=="string"){
        rowIds=rowIds.split(";");
    }
    let imgNames = [];
    let imgShowObj = this;
    rowIds.forEach(function (rowId) {
        for (let num = 0; num < imgShowObj.vueObj.items.length; num++) {
            let itemObj = imgShowObj.vueObj.items[num];
            if (itemObj.id === rowId) {
                imgNames.push(itemObj.name);
            }
        }
    });
    return imgNames;
};
/**
 * 刷新图片信息
 * @param url
 * @param params
 * @param successFun
 * @param errorFun
 * @param backType
 */
ImgShowObj.prototype.flushImgByUrl = function ({
                                                   url,
                                                   params = {}
                                               },newPage=false) {
    let imgShowObj = this;
    this.url = url;
    this.params = params;
    //如果newPage为true 则设置当前为第一页
    if(newPage){
        this.vueObj.curPageNum=1;
    }
    let backFun = function (backDataJson) {
        let backData=[];
        //获取数据
        if(backDataJson&&backDataJson["list"]!=null){
            backData=backDataJson["list"];
        }
        if(backDataJson&&backDataJson["records"]!=null){
            backData=backDataJson["records"];
        }
        //获取分页总数
        let  totalCount=backData.length;
        if(backDataJson&&backDataJson["total"]){
            totalCount=backDataJson["total"];
        }
        //重置选中的记录数;1290175555521540098;1300370283931824130
        imgShowObj.recordIds = [];
        if (AssertUtils.isNotNull(backData)) {
            let itemDatas = [];
            //设置记录总数
            imgShowObj.vueObj.totalCount = totalCount;
            //初始化对象的初始值
            backData&&backData.forEach(function (item) {
                itemDatas.push({
                    ...item,
                    ...{
                        hoverFlag: false,
                        showSubMenu: false,
                        editorName: false,
                        selFlag: false
                    }
                });
            });
            imgShowObj.vueObj.items = [...itemDatas];
        }
    };
    let queryCommand = new QueryCommand({url:url,size:this.vueObj.pageSize,current:this.vueObj.curPageNum});
    params["current"]=this.vueObj.curPageNum;
    queryCommand.executeQuery({params, successFun:backFun});
};
export default ImgShowObj;



// WEBPACK FOOTER //
// ./goingsrc/jsCom/comCtl/ImgShowObj.js